import { MetricKey, WeeklyStatisticsResponse } from '../model/WeeklyStatisticsResponse';
import { METRICS } from './config';

export * from './config';
export * from './formatters';
export * from './thresholds';

export const sortByWeekAsc = (weeks: WeeklyStatisticsResponse[]): WeeklyStatisticsResponse[] =>
  [...weeks].sort((a, b) => new Date(a.weekStart).getTime() - new Date(b.weekStart).getTime());

export const calculateTotals = (weeks: WeeklyStatisticsResponse[]): Record<MetricKey, number> =>
  weeks.reduce<Record<MetricKey, number>>(
    (acc, w) => {
      METRICS.forEach((m) => {
        acc[m.key] = (acc[m.key] ?? 0) + w[m.key];
      });
      return acc;
    },
    {} as Record<MetricKey, number>,
  );
